import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/smartcard.svg'
import _imports_1 from './assets/desktop.svg'
import _imports_2 from './assets/birdid.svg'
import _imports_3 from './assets/lock.svg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "breadcrumb-wrapper pt-3" }
const _hoisted_3 = { class: "options-wrapper" }
const _hoisted_4 = { class: "py-3" }

import { useRoute } from 'vue-router'
  import { ArDataType, useAR } from '@/store/Pinia/useAR.store'
  import Contact from '@/components/Molecules/Contact.vue'
  import Breadcrumb from '@/components/Molecules/Breadcrumbs.vue'
  import arController from '@/infra/BirdId/controllers/ar.controller'
  import CardContainerWithHoverShadow from './components/Atoms/CardContainerWithHoverShadow.vue'
  import { onBeforeMount } from 'vue'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'DigitalCertificateInstallationGuide',
  setup(__props) {

  const pathList = {
    'Instalar Certificado': 'guia-de-instalacao-de-certificado-digital',
  }

  onBeforeMount(async () => {
    const route = useRoute()
    const arStore = useAR()
    const arSubDomain =
      route.params.arsubdomain || arStore.arData.subdomain || 'arsoluti'

    const arDataClean = {
      subdomain: '',
      nomeAr: '',
      logo: '',
      foneAR: '',
      siteAR: '',
      emissorLink: '',
    }

    if (arSubDomain === arStore.arData.subdomain) {
      return
    }

    arStore.setArData(arDataClean)
    await arController
      .getArData(`${arSubDomain}`)
      .then(({ data: dataAr }) => {
        const modalSave = { ...arDataClean, ...dataAr, subdomain: arSubDomain }
        arStore.setArData(modalSave as ArDataType)
      })
      .catch(() => {
        arStore.setArData(arDataClean as ArDataType)
      })
  })

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(Breadcrumb, { "path-list": pathList })
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("section", { class: "page-title-wrapper text-start pt-4" }, [
      _createElementVNode("h2", { class: "fw-600" }, "Guia de instalação de Certificado Digital")
    ], -1)),
    _cache[5] || (_cache[5] = _createElementVNode("section", { class: "pt-5" }, [
      _createElementVNode("p", { class: "fs-6 text-start" }, " Aqui, disponibilizamos todos os guias de instalação para os diferentes tipos de certificados que você adquiriu. Escolha o seu tipo de certificado e simplifique o processo de instalação. ")
    ], -1)),
    _createElementVNode("section", _hoisted_3, [
      _createVNode(CardContainerWithHoverShadow, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_link, {
            to: { name: 'installationToken' },
            class: "d-flex align-items-center flex-column pt-5 pb-2"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                width: "124",
                height: "110",
                src: _imports_0,
                alt: "smartcard"
              }, null, -1),
              _createElementVNode("span", { class: "mt-4" }, [
                _createTextVNode("A3 com instalação em "),
                _createElementVNode("strong", null, "Token ou smartcard")
              ], -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(CardContainerWithHoverShadow, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_link, {
            to: "/issue/plugin",
            class: "d-flex align-items-center flex-column pt-5 pb-2"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createElementVNode("img", {
                width: "128",
                height: "110",
                src: _imports_1,
                alt: "desktop"
              }, null, -1),
              _createElementVNode("span", { class: "mt-4" }, [
                _createTextVNode("A1 com instalação direta no "),
                _createElementVNode("strong", null, "Computador")
              ], -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(CardContainerWithHoverShadow, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_link, {
            to: "/installation-guide-birdid",
            class: "d-flex align-items-center flex-column pt-5 pb-2"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("img", {
                width: "73",
                height: "110",
                src: _imports_2,
                alt: "birdid"
              }, null, -1),
              _createElementVNode("span", { class: "mt-4" }, [
                _createTextVNode("Certificado em nuvem "),
                _createElementVNode("strong", null, "Bird ID")
              ], -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(CardContainerWithHoverShadow, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_link, {
            to: "/ssl-certificate/installation-guide-ssl",
            class: "d-flex align-items-center flex-column pt-5 pb-2"
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createElementVNode("img", {
                width: "80",
                height: "110",
                src: _imports_3,
                alt: "lock"
              }, null, -1),
              _createElementVNode("span", { class: "mt-4" }, [
                _createTextVNode("Certificados "),
                _createElementVNode("strong", null, "Financeiros e SSL")
              ], -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createVNode(Contact)
    ])
  ]))
}
}

})